import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mockData';
import { useLanguage } from '../context/LanguageContext';

const FAQ = () => {
  const { t } = useLanguage();
  
  return (
    <section id="faq" style={{
      padding: '120px 24px',
      background: 'var(--bg-primary)',
      position: 'relative'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto'
      }}>
        {/* Section Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '64px'
        }}>
          <h2 style={{
            fontSize: '48px',
            fontWeight: 700,
            marginBottom: '16px',
            color: 'var(--text-primary)'
          }} className="display-md">
            {t('faq.title')}
          </h2>
          <p style={{
            fontSize: '18px',
            color: 'var(--text-secondary)'
          }} className="body-lg">
            {t('faq.subtitle')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              style={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border-subtle)',
                borderRadius: '16px',
                marginBottom: '16px',
                padding: '8px 16px',
                transition: 'all 0.2s ease'
              }}
            >
              <AccordionTrigger
                style={{
                  fontSize: '18px',
                  fontWeight: 600,
                  color: 'var(--text-primary)',
                  textAlign: 'left',
                  padding: '16px 0'
                }}
              >
                {faq.question}
              </AccordionTrigger>
              <AccordionContent
                style={{
                  fontSize: '16px',
                  lineHeight: 1.7,
                  color: 'var(--text-muted)',
                  paddingBottom: '16px',
                  whiteSpace: 'pre-line'
                }}
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact CTA */}
        <div style={{
          marginTop: '64px',
          textAlign: 'center',
          background: 'var(--bg-secondary)',
          border: '1px solid var(--border-subtle)',
          borderRadius: '20px',
          padding: '48px 40px'
        }}>
          <h3 style={{
            fontSize: '28px',
            fontWeight: 600,
            marginBottom: '16px',
            color: 'var(--text-primary)'
          }}>
            Still Have Questions?
          </h3>
          <p style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            marginBottom: '24px'
          }}>
            Our support team is available 24/7 to help you get started
          </p>
          <button
            onClick={() => window.open('https://t.me/propindexa', '_blank')}
            className="btn-primary"
            style={{
              padding: '14px 32px'
            }}
          >
            Contact Support
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;